import { ReactElement } from 'react';
import { StyledAccordion, StyledAccordionDetails, StyledAccordionSummary } from 'hooks/StyledComponents';
import { useFormikContext } from 'formik';
import uniqueId from 'lodash/uniqueId';
import startCase from 'lodash/startCase';

// Components
import { FormikNumberField } from 'components/ContinuousImprovement/PureFormElements';

// Types
import { IFacetProps, SearchRequest } from 'components/ContinuousImprovement/Facets/types';

export const Range = (props: IFacetProps): ReactElement => {
  const { callback, expandIcon, facet, isDisabled, isExpanded, onToggleExpand } = props;
  const { setFieldValue } = useFormikContext<SearchRequest>();
  const { displayValue, rangeEndValue, rangeStartValue, rangeEndPlaceholderValue, rangeStartPlaceholderValue } = facet;

  const onKeyPress = (e, formikKey): void => {
    const value = e.target.value;
    setFieldValue(formikKey, value);

    // Clicking the enter button should call the callback.
    if (e.which === 13) {
      callback?.();
    }
  };

  const endLabel = rangeEndPlaceholderValue || startCase(rangeEndValue);
  const startLabel = rangeStartPlaceholderValue || startCase(rangeStartValue);

  return (
    <StyledAccordion key={displayValue} expanded={isExpanded} onChange={onToggleExpand}>
      <StyledAccordionSummary expandIcon={expandIcon} id={uniqueId()}>
        {displayValue}
      </StyledAccordionSummary>
      <StyledAccordionDetails>
        <span className="search-box--small" style={{ width: 'auto' }}>
          <FormikNumberField
            disabled={isDisabled}
            formikKey={rangeStartValue}
            label={startLabel}
            onKeyPress={(e) => onKeyPress(e, rangeStartValue)}
            placeholder={startLabel}
          />
        </span>
        <span className="search-box--small" style={{ width: 'auto' }}>
          <FormikNumberField
            disabled={isDisabled}
            formikKey={rangeEndValue}
            label={endLabel}
            onKeyPress={(e) => onKeyPress(e, rangeEndValue)}
            placeholder={endLabel}
          />
        </span>
      </StyledAccordionDetails>
    </StyledAccordion>
  );
};
